<template>
    <div class="w-full px-5 pt-3">
      <div class="flex justify-start items-center space-x-3 mb-1">
        <div class="py-2.5">
            <button
              v-for="(tab, index) in tabs"
              :key="index"
              @click="activeTab = index"
              :class="[
                activeTab === index
                  ? 'text-white transition-all ease-in rounded-md bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br px-5 py-2.5 text-center'
                  : '',
                'px-4 py-2 focus:outline-none transition-colors ease-in rounded-md',
              ]"
            >
              {{ tab }}
            </button>
          </div>
        <div v-show="activeTab === 0" class="flex flex-col" style="margin-left: auto">
          <div class="w-40">
            <button
              @click="$router.push({ path: '/addGuaranteeFundUZS' })"
              class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center"
            >
              Добавить - UZS
            </button>
          </div>
        </div>
        <div v-show="activeTab === 1" class="flex flex-col" style="margin-left: auto">
          <div class="w-40">
            <button
              @click="$router.push({ path: '/addGuaranteeFundUSD' })"
              class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center"
            >
              Добавить - USD
            </button>
          </div>
        </div>
        <div v-show="activeTab === 2" class="flex flex-col" style="margin-left: auto">
          <div class="w-40">
            <button
              @click="$router.push({ path: '/addGuaranteeFundEUR' })"
              class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center"
            >
              Добавить - EUR
            </button>
          </div>
        </div>
         
        </div>
      
        <div class="overflow-x-auto mx-0">
          <div v-show="activeTab === 0" class="py-2 align-middle inline-block min-w-full">
            <div
              class="border overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-100">
                  <tr>
                    <th
                      scope="col"
                      class="w-24 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Изменить 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Код 
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Наименование
                    </th>
                    <th
                      scope="col"
                      class="w-24 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Сумма 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Валюта 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Дата 
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr
                    v-for="(item, index) in guaranteeFundsUZS"
                    :key="index"
                  >
                  <td
                      class="text-center whitespace-nowrap text-sm text-gray-500 border-l"
                    >
                      <button
                        @click="getToGuaranteeFundEditUZS(item)"
                        class="hover:text-blue-500"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-6 h-6 transition ease-linear mx-auto"
                        >
                          <path
                            d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z"
                          />
                          <path
                            d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z"
                          />
                        </svg>
                        <p class="text-xs">изменить</p>
                      </button>
                    </td>
                    <td
                      class="whitespace-nowrap text-sm text-gray-500 font-mono border-r text-center"
                    >
                      {{ item.id }}
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.code }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.name }}
                      </p>
                    </td> 
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.fund }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.currency }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                       {{ item.date }}
                      </p>
                    </td> 
                  </tr>
                  <tr v-if="guaranteeFundsUZS.length === 0">
                    <td
                      colspan="2"
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      Запрашиваемый элемент не найден.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-show="activeTab === 1" class="py-2 align-middle inline-block min-w-full">
            <div
              class="border overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-100">
                  <tr>
                    <th
                      scope="col"
                      class="w-24 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Изменить 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Код 
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Наименование
                    </th>
                    <th
                      scope="col"
                      class="w-24 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Сумма 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Валюта 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Дата 
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr
                    v-for="(item, index) in guaranteeFundsUSD"
                    :key="index"
                  >
                  <td
                      class="text-center whitespace-nowrap text-sm text-gray-500 border-l"
                    >
                      <button
                        @click="getToGuaranteeFundEditUSD(item)"
                        class="hover:text-blue-500"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-6 h-6 transition ease-linear mx-auto"
                        >
                          <path
                            d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z"
                          />
                          <path
                            d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z"
                          />
                        </svg>
                        <p class="text-xs">изменить</p>
                      </button>
                    </td>
                    <td
                      class="whitespace-nowrap text-sm text-gray-500 font-mono border-r text-center"
                    >
                      {{ item.id }}
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.code }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.name }}
                      </p>
                    </td> 
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.fund }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.currency }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                       {{ item.date }}
                      </p>
                    </td> 
                  </tr>
                  <tr v-if="guaranteeFundsUSD.length === 0">
                    <td
                      colspan="2"
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      Запрашиваемый элемент не найден.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-show="activeTab === 2" class="py-2 align-middle inline-block min-w-full">
            <div
              class="border overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-100">
                  <tr>
                    <th
                      scope="col"
                      class="w-24 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Изменить 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Код 
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Наименование
                    </th>
                    <th
                      scope="col"
                      class="w-24 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Сумма 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Валюта 
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Дата 
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr
                    v-for="(item, index) in guaranteeFundsEUR"
                    :key="index"
                  >
                  <td
                      class="text-center whitespace-nowrap text-sm text-gray-500 border-l"
                    >
                      <button
                        @click="getToGuaranteeFundEditEUR(item)"
                        class="hover:text-blue-500"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-6 h-6 transition ease-linear mx-auto"
                        >
                          <path
                            d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z"
                          />
                          <path
                            d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z"
                          />
                        </svg>
                        <p class="text-xs">изменить</p>
                      </button>
                    </td>
                    <td
                      class="whitespace-nowrap text-sm text-gray-500 font-mono border-r text-center"
                    >
                      {{ item.id }}
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.code }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.name }}
                      </p>
                    </td> 
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.fund }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                        {{ item.currency }}
                      </p>
                    </td>
                    <td
                      class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p 
                        class="px-6 py-1 whitespace-nowrap text-sm text-gray-500 "
                      >
                       {{ item.date }}
                      </p>
                    </td> 
                  </tr>
                  <tr v-if="guaranteeFundsEUR.length === 0">
                    <td
                      colspan="2"
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      Запрашиваемый элемент не найден.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isOpenEditUZS" class="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
            <div class="w-2/4 bg-white rounded-lg p-4">
              <h2 class="font-bold text-blue-500 text-xl flex items-center">
                    <button @click="exitFromEditModalUZS()" class="pr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8">
                    <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clip-rule="evenodd" />
                    </svg>
                    </button>
                    Форма изменения
            </h2>
              <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Код</label
            >
              <input
              id="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.code"
            />
            <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Наименование</label
            >
              <input
              id="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.name"
            />
            <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Сумма</label
            >
              <input
              id="number"
              type="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.fund"
            />
            <div class="flex float-right" style="margin-left: auto">
                  <div class="w-40">
                      <button
                      @click="saveEditUZS()"
                      class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center"
                      >
                      Сохранить
                      </button>
                  </div>
            </div>
          </div>
      </div>

      <div v-if="isOpenEditUSD" class="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
            <div class="w-2/4 bg-white rounded-lg p-4">
              <h2 class="font-bold text-blue-500 text-xl flex items-center">
                    <button @click="exitFromEditModalUSD()" class="pr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8">
                    <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clip-rule="evenodd" />
                    </svg>
                    </button>
                    Форма изменения
            </h2>
              <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Код</label
            >
              <input
              id="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.code"
            />
            <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Наименование</label
            >
              <input
              id="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.name"
            />
            <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Сумма</label
            >
              <input
              id="number"
              type="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.fund"
            />
            <div class="flex float-right" style="margin-left: auto">
                  <div class="w-40">
                      <button
                      @click="saveEditUSD()"
                      class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center"
                      >
                      Сохранить
                      </button>
                  </div>
            </div>
          </div>
      </div>

      <div v-if="isOpenEditEUR" class="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
            <div class="w-2/4 bg-white rounded-lg p-4">
              <h2 class="font-bold text-blue-500 text-xl flex items-center">
                    <button @click="exitFromEditModalEUR()" class="pr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8">
                    <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clip-rule="evenodd" />
                    </svg>
                    </button>
                    Форма изменения
            </h2>
              <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Код</label
            >
              <input
              id="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.code"
            />
            <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Наименование</label
            >
              <input
              id="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.name"
            />
            <label
              for="cover"
              class="block mt-5 mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >Сумма</label
            >
              <input
              id="number"
              type="number"
              rows="4"
              class="rounded-md block p-2.5 w-full text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2"
              v-model="this.guarantee.fund"
            />
            <div class="flex float-right" style="margin-left: auto">
                  <div class="w-40">
                      <button
                      @click="saveEditEUR()"
                      class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center"
                      >
                      Сохранить
                      </button>
                  </div>
            </div>
          </div>
      </div>
        <div v-show="loading">
    <LoadingPage message="Выполняется загрузка ..."></LoadingPage>
    </div>
  </template>
  
  <script>
  import LoadingPage from "./LoadingPage.vue";
  import { toast } from "vue3-toastify";
  export default {
    beforeRouteEnter(to, from, next) {
      sessionStorage.removeItem("CURRENT_ITEM");
      next();
    },
    components: {
      LoadingPage
    },
    data() {
      return {
        guarantee:null,
        guaranteeFundsUZS: [],
        guaranteeFundsUSD: [],
        guaranteeFundsEUR: [],
        isOpenEditUZS: false,
        isOpenEditUSD: false,
        isOpenEditEUR: false,
        loading: true,
        activeTab: 0,
        tabs: ["UZS", "USD", "EUR"],
      };
    },
    computed: {
     
    },
    methods: {
      async loadTableDataUZS() {
        this.axios
          .get("/api/Admin/GuaranteeFund/GetLastUZS")
          .then((response) => {
            this.guaranteeFundsUZS = response.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      async loadTableDataUSD() {
        this.axios
          .get("/api/Admin/GuaranteeFund/GetLastUSD")
          .then((response) => {
            this.guaranteeFundsUSD = response.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      async loadTableDataEUR() {
        this.axios
          .get("/api/Admin/GuaranteeFund/GetLastEUR")
          .then((response) => {
            this.guaranteeFundsEUR = response.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },


      
      getToGuaranteeFundEditUZS(item){
        this.guarantee = item;
        this.isOpenEditUZS = !this.isOpenEditUZS;
      },
      exitFromEditModalUZS(){
        this.guarantee = null;
        this.isOpenEditUZS = !this.isOpenEditUZS;
      },
      async saveEditUZS(){
        if(this.guarantee.code != null && this.guarantee.name != null && this.guarantee.fund != null && this.guarantee.code != "" && this.guarantee.name != ""){
        
          this.guaranteeFundsUZS = this.guaranteeFundsUZS.filter(item => {
                if (item.id === this.guarantee.id) {
                item.fund = this.guarantee.fund;
                item.code = this.guarantee.code;
                item.name = this.guarantee.name;
                }
                return item;
                
            });
              const response = await this.axios.post(
                  "api/Admin/GuaranteeFund/Edit",
                  this.guarantee, {
                      headers: {
                          "Content-Type": "application/json",
                      },
                  }
              );
              if (response.status === 200) {
                  toast.success("успешно изменена", {
                      position: "top-center",
                      transition: "flip",
                      newestOnTop: true,
                      toastStyle: {
                          fontSize: "14px",
                      },
                  });
              }
            this.guarantee = null;
            this.isOpenEditUZS = !this.isOpenEditUZS;
        }
        else
          toast.error("Ошибка. Заполните все поля!", {
                  position: "top-center",
                  transition: "flip",
                  newestOnTop: true,
                  toastStyle: {
                      fontSize: "14px",
                  },
              });
      },

      getToGuaranteeFundEditUSD(item){
        this.guarantee = item;
        this.isOpenEditUSD = !this.isOpenEditUSD;
      },
      exitFromEditModalUSD(){
        this.guarantee = null;
        this.isOpenEditUSD = !this.isOpenEditUSD;
      },
      async saveEditUSD(){
        if(this.guarantee.code != null && this.guarantee.name != null && this.guarantee.fund != null && this.guarantee.code != "" && this.guarantee.name != ""){
        
          this.guaranteeFundsUSD = this.guaranteeFundsUSD.filter(item => {
                if (item.id === this.guarantee.id) {
                item.fund = this.guarantee.fund;
                item.code = this.guarantee.code;
                item.name = this.guarantee.name;
                }
                return item;
                
            });
              const response = await this.axios.post(
                  "api/Admin/GuaranteeFund/Edit",
                  this.guarantee, {
                      headers: {
                          "Content-Type": "application/json",
                      },
                  }
              );
              if (response.status === 200) {
                  toast.success("успешно изменена", {
                      position: "top-center",
                      transition: "flip",
                      newestOnTop: true,
                      toastStyle: {
                          fontSize: "14px",
                      },
                  });
              }
            this.guarantee = null;
            this.isOpenEditUSD = !this.isOpenEditUSD;
        }
        else
          toast.error("Ошибка. Заполните все поля!", {
                  position: "top-center",
                  transition: "flip",
                  newestOnTop: true,
                  toastStyle: {
                      fontSize: "14px",
                  },
              });
      },

      getToGuaranteeFundEditEUR(item){
        this.guarantee = item;
        this.isOpenEditEUR = !this.isOpenEditEUR;
      },
      exitFromEditModalEUR(){
        this.guarantee = null;
        this.isOpenEditEUR = !this.isOpenEditEUR;
      },
      async saveEditEUR(){
        if(this.guarantee.code != null && this.guarantee.name != null && this.guarantee.fund != null && this.guarantee.code != "" && this.guarantee.name != ""){
        
          this.guaranteeFundsEUR = this.guaranteeFundsEUR.filter(item => {
                if (item.id === this.guarantee.id) {
                item.fund = this.guarantee.fund;
                item.code = this.guarantee.code;
                item.name = this.guarantee.name;
                }
                return item;
                
            });
              const response = await this.axios.post(
                  "api/Admin/GuaranteeFund/Edit",
                  this.guarantee, {
                      headers: {
                          "Content-Type": "application/json",
                      },
                  }
              );
              if (response.status === 200) {
                  toast.success("успешно изменена", {
                      position: "top-center",
                      transition: "flip",
                      newestOnTop: true,
                      toastStyle: {
                          fontSize: "14px",
                      },
                  });
              }
            this.guarantee = null;
            this.isOpenEditEUR = !this.isOpenEditEUR;
        }
        else
          toast.error("Ошибка. Заполните все поля!", {
                  position: "top-center",
                  transition: "flip",
                  newestOnTop: true,
                  toastStyle: {
                      fontSize: "14px",
                  },
              });
      },

    },


  mounted() {
    this.loadTableDataUZS();
    this.loadTableDataUSD();
    this.loadTableDataEUR();
  }
}
  </script>
  
  <style>
  .active {
    background-color: #3b82f6;
    color: white;
  }
  .btn {
    margin-left: auto;
  }
  </style>
  